import React, { useEffect, useState } from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemButton,
} from 'react-accessible-accordion';

import css from './ListingPage.module.css';
import { formatMoney } from '../../util/currency';
import classNames from 'classnames';
import { types as sdkTypes } from '../../util/sdkLoader';
import { getAllTimeValues, getAvailableStartTimes } from './helper';
import { isPrivateListing } from '../../util/listingHelpers';

const { Money } = sdkTypes;

let accordion_key = 12345;

const SectionDurationMaybe = props => {
  const {
    durationListingConfig,
    monthlyTimeSlots,
    intl,
    timeZone,
    handleExternalChange,
    price,
    seats = 1,
    marketplaceCurrency,
    isBookingDateChanged,
    optionDuration,
    updatedOptionDuration,
    currentListing,
  } = props;

  if (!monthlyTimeSlots) return null;

  const [startTimes, setStartTimes] = useState([]);
  const [selectedTime, setSelectedTime] = useState(null);
  const [selectedDuration, setDuration] = useState(null);
  const [bookingDate, setBookingDate] = useState(isBookingDateChanged);

  // if (durationListingConfig.length === 0) return null;
  if (optionDuration === undefined) return null;
  if (updatedOptionDuration === undefined) return null;

  const { timeSlots, startDate } = monthlyTimeSlots;

  const options = updatedOptionDuration.map(option => {
    return {
      duration: option.duration,
      price: option.price,
      option: option.duration,
      description: option.description,
    }
  });

  if (selectedDuration === null) {
    setDuration(options[0].duration);
  }

  useEffect(() => {
    if (isBookingDateChanged !== bookingDate) {
      setBookingDate(isBookingDateChanged);
      accordion_key++;
    }
  }, [isBookingDateChanged]);

  useEffect(() => {
    const startTimeInterval = ['hour'];
    const currentDuration = selectedDuration !== null ? selectedDuration : options[0].duration;
    const bookingLengthInMinutes = currentDuration * 60;

    const availableStartTimes = getAvailableStartTimes({
      intl,
      timeZone,
      bookingStart: startDate,
      timeSlotsOnSelectedDate: timeSlots,
      bookingLengthInMinutes,
      startTimeInterval,
    });

    if (selectedTime === null || isBookingDateChanged) {
      setSelectedTime(availableStartTimes[0]?.timestamp);
    }

    setStartTimes(availableStartTimes);

  }, [selectedDuration, isBookingDateChanged]);

  const selectDuration = (e, index) => {
    e.preventDefault();
    // e.stopPropagation();
    setDuration(index.option);

    console.log(index, 'index')

    selectTimes(e, startTimes[0], index.option, index.price)
  };


  const selectTimes = (e, index, duration, price) => {
    e.preventDefault();

    const startTimeInterval = ['hour'];
    const currentDuration = duration ? duration : selectedDuration;
    // const timeUnitConfig = bookingTimeUnits[currentDuration];
    // const bookingLengthInMinutes = timeUnitConfig.timeUnitInMinutes;
    const bookingLengthInMinutes = currentDuration * 60;

    console.log(currentDuration, 'currentDuration')

    setSelectedTime(index.timestamp);

    const { startTime, endTime } = getAllTimeValues(
      intl,
      timeZone,
      timeSlots,
      startDate,
      index.timestamp,
      bookingLengthInMinutes,
      startTimeInterval,
      true
    );

    const params = {
      startTime: index.timestamp,
      startDate,
      endTime,
      price
    };

    handleExternalChange(params);
  };

  const renderStartTimes = startTimes.map((startTime, index) => {

    return (
      <p key={startTime + index} className={classNames(css.timeItem, startTime.timestamp === selectedTime && css.timeItemActive)} onClick={e => selectTimes(e, startTime)}>
        {startTime.timeOfDay}
      </p>
    );
  });

  const maxSeats = currentListing?.attributes?.publicData?.maxSeats;
  const upToSeats = isPrivateListing(currentListing) ? maxSeats : seats;

  const renderItem = options.map((item, index) => {
    const changedPrice = new Money(item.price, marketplaceCurrency);
    const formattedPrice = formatMoney(intl, changedPrice);
    const description = item.description;

    const formattedDescription = description?.split('\n').map((line, index) => (
      <span key={index} style={{ display: 'block', marginBottom: '0.5em' }}>
        {line}
      </span>
    ));

    return (
      <AccordionItem uuid={index} key={index}>
        <AccordionItemHeading onClickCapture={(e) => selectDuration(e, item)}>
          <AccordionItemButton>
            <div
              className={css.titleWrapper}
              role="button"
              tabIndex={0}
            >
              <div className={css.titleHolder}>
                {/*<h4 className={css.panelTitle}>Option {index + 1}</h4>*/}
                <h4 className={css.panelTitle}>Duration {item.duration} h</h4>
              </div>

              <div className={css.priceHolder}>
                <span className={css.priceValue}>{formattedPrice} </span>
                <span className={css.perUnit}>per group
                  <span className={css.upToSeats}>(up to {upToSeats})</span>
                </span>
              </div>
            </div>
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <div className={css.panelWrapper}>
            <div className={css.timesHolder}>{renderStartTimes}</div>
            <p className={css.description}>{formattedDescription}</p>
            <div className={css.buttonHolder}>
              {/*<PrimaryButton className={css.button}>Reserve</PrimaryButton>*/}
            </div>
          </div>
        </AccordionItemPanel>
      </AccordionItem>
    );
  });

  return (
    <div className={css.sectionContent}>
      <div className={css.blockContainer}>
        <div className={css.accordion} key={accordion_key}>
          <Accordion key="becomeAHostPageFAQ" preExpanded={[0]}>
            {renderItem}
          </Accordion>
        </div>
      </div>
    </div>
  );
};

export default SectionDurationMaybe;
